<template>
    <div class="calendar">
        <div class="header">{{ year }} {{ monthName }}</div>
        <div class="weekdays">
            <div v-for="day in weekdays" :key="day" class="weekday">{{ day }}</div>
        </div>
        <div class="days">
            <div v-for="(day, index) in days" :key="index" class="day" :class="{
                selected: isSelected(day, index),
                'in-range': isInRange(day, index),
                'hovered': isHovered(day, index),
                'other-month': isOtherMonth(index),
                'disabled': isOtherMonth(index),
                'special-date': isSpecialDate(day, index),
                'replace-date': isReplaceDate(day, index)
            }" @click="selectDay(day, index, $event)" @mouseenter="handleHover(day, index)"
                @contextmenu.prevent="openContextMenu(day, index, $event)">
                <a-popover placement="bottom" v-if="getDateData(day)[0] && getDateData(day)[0].calendarSettingDTOList"
                    :mouseEnterDelay="1">
                    <!-- <a-popover placement="bottom" v-if="shouldShowPopover(day, index)" :mouseEnterDelay="1"> -->
                    <template slot="content">
                        <div v-for="item in getDateData(day)[0].calendarSettingDTOList" :key="item.id" class="bor-top">
                            <div v-if="item.dateSetting">
                                <p>{{ item.dateType == 2 ? '全局节假日' : item.dateType == 4 ? '教育局设置' : item.dateType == 8 ?
                                    '学校设置' : '' }} : <span v-if="item.dateSetting == -1">{{ item.dateItem }}{{
                                        !item.replaceDate ? '放假' : '调课至' +
                                            item.replaceDate }}</span><span v-if="item.dateSetting == 1">{{
                                            item.parentDateItem }}调课至{{
                                            item.dateItem }}</span>
                                </p>
                                <p v-if="item.comment">备注： {{ item.comment }}</p>
                            </div>
                        </div>
                    </template>
                    <template slot="title">
                        <span style="font-weight: bold;">
                            {{ getDateData(day)[0].calendarSettingDTOList[0].dateItem }}
                            {{ getDateData(day)[0].calendarSettingDTOList[0].dateSetting == 1 ? '调课' : '放假' }}
                        </span>
                    </template>
                    {{ day || '' }}
                </a-popover>
                <span v-else>{{ day || '' }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        year: Number,
        month: Number,
        pause: Boolean,
        selectedRange: {
            type: Object,
            default: () => ({ start: null, end: null })
        },
        hoveredRange: {
            type: Object,
            default: () => ({ start: null, end: null })
        },
        formattedSelectedRange: {
            type: Array,
            default: () => [] // 接收父组件传递的 formattedSelectedRange
        },
        dateData: {
            type: Object,
            default: () => ({})
        },
    },
    data() {
        return {
            days: [],
            weekdays: ['一', '二', '三', '四', '五', '六', '日'] // 星期一到星期日
        };
    },
    computed: {
        monthName() {
            const date = new Date(this.year, this.month);
            return date.toLocaleString('default', { month: 'long' }); // 获取月份名称
        }
    },
    created() {
        this.generateDays();
    },
    watch: {
        year() {
            this.generateDays();
        },
    },
    methods: {
        generateDays() {
            const date = new Date(this.year, this.month, 1); // 当前月份的第一天
            const daysInMonth = new Date(this.year, this.month + 1, 0).getDate(); // 当前月份的总天数
            const firstDayOfWeek = date.getDay(); // 当前月份的第一天是星期几（0=周日, 1=周一, ..., 6=周六）

            // 计算需要补全的上个月日期
            const prevMonthDays = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1; // 如果第一天是周日，补全6天；否则补全 firstDayOfWeek - 1 天
            const prevMonthLastDay = new Date(this.year, this.month, 0).getDate(); // 上个月的最后一天
            const prevMonthDates = Array.from({ length: prevMonthDays }, (_, i) => prevMonthLastDay - prevMonthDays + i + 1);

            // 当前月份的日期
            const currentMonthDates = Array.from({ length: daysInMonth }, (_, i) => i + 1);

            // 计算需要补全的下个月日期
            const totalDays = 42; // 6行 * 7天
            const nextMonthDays = totalDays - (prevMonthDates.length + currentMonthDates.length);
            const nextMonthDates = Array.from({ length: nextMonthDays }, (_, i) => i + 1);

            // 合并所有日期
            this.days = [...prevMonthDates, ...currentMonthDates, ...nextMonthDates];
        },
        selectDay(day, index, event) {
            // pause为true的时候已经选完结束日期，接下来校验点击日期在范围内，在就弹窗，不在则清除
            if (this.pause) {
                if (this.isInRange2(day, index)) {
                    this.$emit('click-menu', { day, event });
                } else {
                    this.$emit('cancel-selection')
                }
                return this.$emit('add-cal')
            }
            if (!this.isOtherMonth(index)) {
                this.$emit('select-day', { day, month: this.month, year: this.year });
            }
        },
        handleHover(day, index) {
            if (!this.isOtherMonth(index)) {
                this.$emit('hover-day', { day, month: this.month, year: this.year });
            }
        },
        isSelected(day, index) {
            // 判断是否是选中的起始日期或结束日期
            const { start, end } = this.selectedRange;
            if (!start || !end || this.isOtherMonth(index)) return false;
            const currentDate = new Date(this.year, this.month, day).getTime();
            const startDate = new Date(start.year, start.month, start.day).getTime();
            const endDate = new Date(end.year, end.month, end.day).getTime();
            return currentDate === startDate || currentDate === endDate;
        },
        isInRange(day, index) {
            // 判断是否在选中的日期范围内
            const { start, end } = this.selectedRange;
            if (!start || !end || this.isOtherMonth(index)) return false;
            const currentDate = new Date(this.year, this.month, day).getTime();
            const startDate = new Date(start.year, start.month, start.day).getTime();
            const endDate = new Date(end.year, end.month, end.day).getTime();
            return currentDate > startDate && currentDate < endDate;
        },
        isInRange2(day, index) {
            // 判断是否在选中的日期范围内
            const { start, end } = this.selectedRange;
            if (!start || !end || this.isOtherMonth(index)) return false;
            const currentDate = new Date(this.year, this.month, day).getTime();
            const startDate = new Date(start.year, start.month, start.day).getTime();
            const endDate = new Date(end.year, end.month, end.day).getTime();
            return currentDate >= startDate && currentDate <= endDate;
        },
        isHovered(day, index) {
            // 判断是否在 hover 的日期范围内
            const { start, end } = this.hoveredRange;
            if (!start || !end || this.isOtherMonth(index)) return false;
            const currentDate = new Date(this.year, this.month, day).getTime();
            const startDate = new Date(start.year, start.month, start.day).getTime();
            const endDate = new Date(end.year, end.month, end.day).getTime();
            return currentDate >= startDate && currentDate <= endDate;
        },
        isOtherMonth(index) {
            // 判断日期是否属于当前月份
            const date = new Date(this.year, this.month, 1);
            const firstDayOfWeek = date.getDay();
            const prevMonthDays = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;

            // 如果 index 小于 prevMonthDays 或大于等于 prevMonthDays + 当前月份的天数，则属于其他月份
            return index < prevMonthDays || index >= prevMonthDays + new Date(this.year, this.month + 1, 0).getDate();
        },
        openContextMenu(day, index, event) {
            if (!this.selectedRange.end) {
                // 如果未选择结束日期，则取消日期范围选择
                this.$emit('cancel-selection');
            }
            // 只有当前月份的日期且日期在 formattedSelectedRange 内才能触发右键菜单
            if (day && !this.isOtherMonth(index) && this.isDateInFormattedRange(day)) {
                this.$emit('add-cal')
                this.$emit('context-menu', { day, event });
            } else {
                this.$emit('cancel-selection');
            }
        },
        isDateInFormattedRange(day) {
            // 判断当前日期是否在 formattedSelectedRange 内
            const currentDate = new Date(this.year, this.month, day).toLocaleDateString('en-CA');
            return this.formattedSelectedRange.some((item) => item.dateItem === currentDate);
        },
        isSpecialDate(day, index) {
            // 判断是否是特殊日期（dateSetting 为 -1）
            if (this.isOtherMonth(index)) return false;
            const currentDate = new Date(this.year, this.month, day).toLocaleDateString('en-CA');
            const dateItems = this.dateData[currentDate] || [];
            return dateItems.some((item) => {
                const lastSetting = item.calendarSettingDTOList[item.calendarSettingDTOList.length - 1];
                return lastSetting && lastSetting.dateSetting === -1;
            });
        },
        isReplaceDate(day, index) {
            // 判断是否是 replaceDate 所指的日期
            if (this.isOtherMonth(index)) return false;
            const currentDate = new Date(this.year, this.month, day).toLocaleDateString('en-CA');
            const dateItems = this.dateData[currentDate] || [];
            return dateItems.some((item) => {
                // return item.calendarSettingDTOList.some((setting) => setting.dateSetting === 1);
                const lastSetting = item.calendarSettingDTOList[item.calendarSettingDTOList.length - 1];
                return lastSetting && lastSetting.dateSetting === 1;
            });
        },
        shouldShowPopover(day, index) {
            // 判断是否显示 popover
            if (this.isOtherMonth(index)) return false;
            const currentDate = new Date(this.year, this.month, day).toLocaleDateString('en-CA');
            const dateItems = this.dateData[currentDate] || [];
            return dateItems.some((item) => {
                const lastSetting = item.calendarSettingDTOList[item.calendarSettingDTOList.length - 1];
                return lastSetting && lastSetting.dateSetting === -1 && !lastSetting.replaceDate;
            });
        },
        getDateData(day) {
            // 获取当前日期的数据
            const currentDate = new Date(this.year, this.month, day).toLocaleDateString('en-CA');
            return this.dateData[currentDate] || [];
        }
    }
};
</script>

<style scoped lang="less">
.calendar {
    font-family: -apple-system;
    display: inline-block;
    margin: 10px;
    padding: 10px;
    width: 262px;
    border: 1px solid #fff;
    border-radius: 4px;
    outline: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
}

.header {
    width: 100%;
    text-align: center;
    font-weight: bold;
    padding-bottom: 6px;
    margin-bottom: 10px;
    border-bottom: 1px solid #e8e8e8;
    color: #262626;
    font-size: 14px;
}

.weekdays {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;
    margin-bottom: 5px;
    margin-bottom: 10px;
}

.weekday {
    width: 30px;
    text-align: center;
    font-weight: bold;
    font-size: 12px;
    color: #555;
}

.days {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;
}

.bor-top {
    border-top: 1px solid #e8e8e8;
    padding: 6px 0;
}

.bor-top:first-child {
    border-top: none;
}

.day {
    width: 30px;
    text-align: center;
    padding: 3px 5px;
    border: 1px solid transparent;
    cursor: pointer;
    border-radius: 4px;

}
.day:nth-child(7n-1),
.day:nth-child(7n){
    background-color: #FBF2E7;
}
.day.disabled {
    pointer-events: none;
    background-color: #fff;
    /* 禁用点击事件 */
}

.day.special-date {
    background-color: #ffbcbc;
    /* 放假背景色 */
}

.day.replace-date {
    background-color: #babaff;
    /* 调课背景色 */
}

.day:hover {
    background-color: #e6f7ff;
}

.day.other-month {
    color: #ccc;
}

// 选中要放最下面
.day.in-range {
    background-color: #bae7ff;
    /* 浅蓝色背景 */
}

.day.hovered {
    background-color: #bae7ff;
    /* hover 效果 */
}

.day.selected {
    color: #fff;
    background-color: #1890ff;
    font-weight: bold;
    border: 1px solid #1890ff;
}
</style>